import { useEffect, useState } from 'react';

interface Props {
  deadlineAt: string;
  onExpire?: () => void;
}

function fmt(ms: number): string {
  if (ms <= 0) return '00:00';
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function CountdownTimer({ deadlineAt, onExpire }: Props) {
  const [remaining, setRemaining] = useState(() => new Date(deadlineAt).getTime() - Date.now());

  useEffect(() => {
    const t = setInterval(() => {
      const r = new Date(deadlineAt).getTime() - Date.now();
      setRemaining(r);
      if (r <= 0) {
        clearInterval(t);
        onExpire?.();
      }
    }, 1000);
    return () => clearInterval(t);
  }, [deadlineAt, onExpire]);

  const danger = remaining < 60_000;
  return (
    <div className={`timer ${danger ? 'timer-danger' : ''}`}>
      <span className="timer-label">Time left</span>
      <span className="timer-value">{fmt(remaining)}</span>
    </div>
  );
}
